var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Dropdown, DropdownVariant } from "./Dropdown";
import { NavLink } from "react-router-dom";
import { joinClasses } from "../../../utils/Filters";
import { ComingSoon } from "../09-views/00-blocks/ComingSoon";
import { asThemeConsumer } from "../../../theme/Theme";
import { ToggleMenuItems } from "./ToggleMenuItems";
export var MenuOrientation;
(function (MenuOrientation) {
    MenuOrientation["VERTICAL"] = "vertical";
    MenuOrientation["HORIZONTAL"] = "horizontal";
})(MenuOrientation || (MenuOrientation = {}));
/* istanbul ignore next */
var getLinkContent = function (item, exact) {
    var itemClazzName = joinClasses(item.active ? "scl--active" : undefined, item.disabled ? "scl--disabled" : undefined);
    return ((item === null || item === void 0 ? void 0 : item.navLink) ?
        (React.createElement(NavLink, { to: item.navLink || "", activeClassName: "scl--active", exact: item.navLink === "/" || exact, onClick: (item === null || item === void 0 ? void 0 : item.link) ? item.link.onClick : undefined },
            item.children,
            item.items && React.createElement("span", { className: "scl-h-text--tiny" },
                "\u00A0(",
                item.items.length,
                ")"),
            !!item.beta && React.createElement(ComingSoon, null))) : (React.createElement("a", __assign({}, item.link, { className: itemClazzName }),
        item.children,
        item.items && React.createElement("span", { className: "scl-h-text--tiny" },
            "\u00A0(",
            item.items.length,
            ")"),
        !!item.beta && React.createElement(ComingSoon, null))));
};
var menuItems = function (newMenuItems, depth, orientation, collapsable) {
    if (newMenuItems) {
        /* istanbul ignore next */
        var processedItems = newMenuItems.map(function (item, index) { return (React.createElement("li", { className: "scl-o-menu__item", key: "menu-item-".concat(depth, "-").concat(index).concat((item.children ? item.children.toString() : "")) }, 
        /* If this is a horizontal menu then add Dropdown with a vertical menu */
        (item.items && depth === 0 &&
            (orientation === MenuOrientation.HORIZONTAL ||
                (orientation === MenuOrientation.VERTICAL && collapsable)) ? (orientation === MenuOrientation.HORIZONTAL) ?
            (React.createElement(Dropdown, { variant: DropdownVariant.MENU, trigger: getLinkContent(item), content: (React.createElement(Menu, { orientation: MenuOrientation.VERTICAL, items: item.items })) })) : (React.createElement(ToggleMenuItems, { trigger: getLinkContent(item, true), content: getMoreMenuItems(item, index, orientation) }))
            :
                (React.createElement(React.Fragment, null,
                    getLinkContent(item, depth === 0 && !!item.items && !collapsable),
                    getMoreMenuItems(item, index, orientation)))))); });
        var processedItemsWrapper = (React.createElement("ul", { className: "scl-o-menu__list" }, processedItems));
        return processedItemsWrapper;
    }
    else {
        return undefined;
    }
};
var getMoreMenuItems = function (item, index, orientation) { return (item.items ? menuItems(item.items, index, orientation) : undefined); };
/**
 *
 * @param props
 */
var MenuComp = function (props) {
    var clazzName = joinClasses(props.className || "", "scl-o-menu", props.orientation === MenuOrientation.VERTICAL ? "scl-o-menu-vertical" : "scl-o-menu-horizontal");
    return (React.createElement("div", { className: clazzName },
        props.title &&
            React.createElement("div", { className: "scl-o-menu__title" },
                React.createElement("a", __assign({}, props.title), props.title.children)),
        props.items ? menuItems(props.items, 0, props.orientation, props.collapsable) : undefined));
};
/**
 *
 */
export var Menu = asThemeConsumer(MenuComp);
export var testUtil = {
    getMoreMenuItems: getMoreMenuItems,
    menuItems: menuItems,
    getLinkContent: getLinkContent,
};
